import api from "../../composables/app";
import { API } from "../apis";

export const getUserDetails = () => {
  const url = `${API.user.details}`;
  return api.get(url);
};
